export const NoteTypeDD = (data) => {
    return {
      type: 'NoteTypeDD',
      payload: data
    }
}